export default __webpack_public_path__ + "static/media/blue_spinner.e5da9cb1.svg";